import { render, staticRenderFns } from "./PelastuskorttiTietokanta.vue?vue&type=template&id=b09a56ce"
import script from "./PelastuskorttiTietokanta.vue?vue&type=script&lang=js"
export * from "./PelastuskorttiTietokanta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports